    export function stopStreamedVideo(videoElem: any) {
        const stream = videoElem.srcObject;
        const tracks = stream?.getTracks() as any
      
        tracks.forEach((track: { stop: () => void; }) => {
          track.stop();
        });
      
        videoElem.srcObject = null;
      }